import { render, staticRenderFns } from "./PnlPage.vue?vue&type=template&id=6cbd01dc"
import script from "./PnlPage.vue?vue&type=script&lang=ts"
export * from "./PnlPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports